import { useMemo } from "react";
import Avatar from "./Avatar";
import Icon from "./icons/Icon";
import { AUFGABEN } from "../aufgaben";
import { farbNummern } from "../spieler";
import "./HistoryList.css";

/**
 * Match-Verlauf: eine Karte pro Runde, auch Runden ohne Punkt.
 * aktionen(eintrag): optionale Bedienelemente (nur beim Host — Umbuchen,
 * Loeschen, siehe Umbuchen unten). namen: alle Spielernamen, damit die
 * Avatare dieselbe Farbe haben wie im Spiel.
 * @category spiel
 */
export function HistoryList({ eintraege, leerText, aktionen, namen }) {
  const alle = namen && namen.length ? namen : eintraege.map((e) => e.playerName).filter(Boolean);
  const schluessel = alle.join("\n");
  const farbe = useMemo(() => farbNummern(schluessel.split("\n")), [schluessel]);

  if (eintraege.length === 0) {
    return <p className="history-leer">{leerText}</p>;
  }
  return (
    <ol className="history-list">
      {eintraege.map((entry) => {
        const aufgabe = AUFGABEN[entry.taskType];
        const meta = [entry.song?.artist, entry.song?.year].filter(Boolean).join(" · ");
        return (
          <li key={entry.id} className="history-entry">
            <div className="history-entry-meta">
              <span>Runde {entry.roundNumber || "?"}</span>
              <span>{entry.timestamp}</span>
            </div>
            <div className="history-song">
              <span className="history-aufgabe" title={aufgabe?.name}>
                <Icon name={aufgabe?.icon || "titel"} size={18} />
              </span>
              <span className="history-song-text">
                <b>{entry.song?.title || "Song"}</b>
                {meta && <small>{meta}</small>}
              </span>
            </div>
            <div className="history-unten">
              {entry.playerName ? (
                <span className="punkt-chip">
                  <Avatar name={entry.playerName} farbe={farbe(entry.playerName)} groesse="klein" />
                  +1 {entry.playerName}
                </span>
              ) : (
                <span className="punkt-chip leer">Kein Punkt</span>
              )}
              {aktionen && aktionen(entry)}
            </div>
          </li>
        );
      })}
    </ol>
  );
}

/**
 * Punkt einer Runde umbuchen (Host): natives Auswahlfeld im Knopf-Look,
 * plus Loeschen. wert: Spieler-Index oder -1 fuer niemand.
 * @category spiel
 */
export function Umbuchen({ wert, spieler, onUmbuchen, onLoeschen }) {
  return (
    <>
      <label className="umbuchen" title="Punkt einem anderen Spieler geben">
        <span>Umbuchen</span>
        <Icon name="pfeil-runter" size={16} />
        <select value={wert} onChange={(e) => onUmbuchen(Number(e.target.value))} aria-label="Punkt umbuchen">
          <option value={-1}>niemand</option>
          {spieler.map((name, idx) => (
            <option key={idx} value={idx}>
              {name}
            </option>
          ))}
        </select>
      </label>
      <button type="button" className="history-loeschen" onClick={onLoeschen} aria-label="Runde löschen" title="Runde löschen">
        <Icon name="muell" size={18} />
      </button>
    </>
  );
}

export default HistoryList;
